export default __webpack_public_path__ + "static/media/message.598d6cca.svg";